import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { VideoLessonDetail } from '@src/components/sco/Education/VideoLessonDetail';
import { EducationPage } from '@src/templates/EducationPage';
import { useParams } from 'next/navigation';
import React, { useEffect } from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const routerParams = useParams();
  const educationContext = useEducationContext();
  useEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
    });
    educationContext.setActiveSection('videos.series.lesson');
  }, []);
  return <VideoLessonDetail videoListSlug={`${routerParams?.videoListSlug}`} videoSlug={`${routerParams?.videoSlug}`} />;
});